import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-charcoal text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 sm:py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 md:gap-12">
          {/* Column 1: Logo & Intro */}
          <div>
            <div className="font-sans font-bold mb-4">
              <div className="text-2xl sm:text-3xl leading-tight text-center">Dan & Van</div>
              <div className="text-[10px] sm:text-xs tracking-[0.2em] font-medium text-gold text-center">REMOVALS</div>
            </div>
            <p className="text-gray-400 text-xs sm:text-sm mb-6">
              Premium removals across Lancashire
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center border border-white/30 rounded-full hover:border-gold hover:text-gold transition-all cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-sm sm:text-base"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center border border-white/30 rounded-full hover:border-gold hover:text-gold transition-all cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-sm sm:text-base"></i>
              </a>
            </div>
          </div>

          {/* Column 2: Services */}
          <div>
            <h3 className="text-gold text-xs uppercase tracking-wider mb-4">Services</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/house-removals" className="text-gray-300 hover:text-gold transition-colors text-xs sm:text-sm cursor-pointer">
                  House Removals
                </Link>
              </li>
              <li>
                <Link to="/office-removals" className="text-gray-300 hover:text-gold transition-colors text-xs sm:text-sm cursor-pointer">
                  Office Removals
                </Link>
              </li>
              <li>
                <Link to="/single-item-moves" className="text-gray-300 hover:text-gold transition-colors text-xs sm:text-sm cursor-pointer">
                  Single Item Moves
                </Link>
              </li>
              <li>
                <Link to="/collections-deliveries" className="text-gray-300 hover:text-gold transition-colors text-xs sm:text-sm cursor-pointer">
                  Collections & Deliveries
                </Link>
              </li>
              <li>
                <Link to="/areas-we-cover" className="text-gray-300 hover:text-gold transition-colors text-xs sm:text-sm cursor-pointer">
                  Areas We Cover
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Company */}
          <div>
            <h3 className="text-gold text-xs uppercase tracking-wider mb-4">Company</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-gold transition-colors text-xs sm:text-sm cursor-pointer">
                  About
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-300 hover:text-gold transition-colors text-xs sm:text-sm cursor-pointer">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="text-gray-300 hover:text-gold transition-colors text-xs sm:text-sm cursor-pointer">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-gold transition-colors text-xs sm:text-sm cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div>
            <h3 className="text-gold text-xs uppercase tracking-wider mb-4">Get in Touch</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <a href="tel:07530166035" className="text-gray-300 hover:text-gold transition-colors text-xs sm:text-sm cursor-pointer">
                  07530 166035
                </a>
              </li>
              <li className="text-gray-400 text-xs sm:text-sm">Lancashire, UK</li>
              <li className="text-gray-400 text-xs sm:text-sm">Mon-Sat: 8am-6pm</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gold/20 mt-8 sm:mt-10 md:mt-12 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center text-xs sm:text-sm text-gray-400 gap-4">
          <p className="text-center md:text-left">&copy; 2025 Dan & Van Removals. All rights reserved.</p>
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors cursor-pointer">
              Website Builder
            </a>
            <span className="hidden sm:inline">•</span>
            <Link to="/privacy" className="hover:text-gold transition-colors cursor-pointer">
              Privacy Policy
            </Link>
            <span className="hidden sm:inline">•</span>
            <Link to="/terms" className="hover:text-gold transition-colors cursor-pointer">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
